import { useTranslation } from 'react-i18next';
import { Button } from '@/common/components/Button/Button';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { ROUTES } from '@/common/constants/routes';
import { useGetEmployeeIdentification } from '@/common/integrations/menhir/employee/employee/employee.hooks';
import {
  ICitizenCard,
  ITransportationCard,
} from '@/common/integrations/menhir/employee/employee/employee.types';
import { IIdentificationSlug } from '@/common/types/general';
import { DocumentSlugIdentificationTypeMapping } from '@/common/utils/documents';
import { Redirect, router, useLocalSearchParams } from 'expo-router';
import { CitizenCardDetail } from './CitizenCardDetail/CitizenCardDetail';
import { TransportationCardDetail } from './TransportationCardDetail/TransportationCardDetail';

export function DocumentDetailPage() {
  const { t } = useTranslation();
  const { documentType } = useLocalSearchParams<{
    documentType: IIdentificationSlug;
  }>();
  const { employeeIdentification: identification, isLoading } =
    useGetEmployeeIdentification(documentType);

  const documentSlug = DocumentSlugIdentificationTypeMapping[documentType];

  if (isLoading) {
    return <LoadingPlaceholder />;
  }

  if (!identification) {
    return <Redirect href={ROUTES.PERSONAL_DETAILS} />;
  }

  return (
    <PageLayout
      headerProps={{
        backButton: true,
        title: t(`dashboard.document_details.${documentSlug}.title`),
        primaryAction: (
          <Button
            onPress={() => {
              router.push({
                pathname: ROUTES.DOCUMENT_FORM,
                params: { documentType },
              });
            }}
          >
            {t('dashboard.document_details.replace_card_label')}
          </Button>
        ),
      }}
    >
      {identification.type === 'citizen_card' && (
        <CitizenCardDetail identification={identification as ICitizenCard} />
      )}
      {identification.type === 'transportation_card' && (
        <TransportationCardDetail
          identification={identification as ITransportationCard}
        />
      )}
    </PageLayout>
  );
}
